import {Injectable} from '@angular/core';
import {DiagramUpdateService} from '../../diagram-data/diagram-update.service';
import {DiagramJsonHandlerService} from '../../diagram-data/diagram-json-handler.service';
import {EditorRegistryService} from '../../diagram-render/mx-graph/editor/editor-registry.service';
import {ChangeCommand} from './change.command';
import {GroupCommand} from './group.command';
import {StickersService} from '../../diagram-interaction/services/stickers.service';
import {ICopyData} from '../../core/services/copy-cells.service';
import {PasteCommand} from './paste.command';
import {ShapeSpawnerService} from '../../diagram-render/shapes/shape-spawner.service';
import {GraphHelperService} from '../../diagram-render/helpers/graph-helper.service';
import {AngularComponentService} from '../../diagram-render/mx-graph/graph/angular-component.service';
import {SanitizeXssService} from '../../core/services/santize-xss.service';
import {SimpleImagePreloadService} from 'src/app/core/services/simple-image-preload.service';

@Injectable()
export class GeneralCommands {
  private serviceObj;

  constructor(
    diagramUpdateSvc: DiagramUpdateService,
    jsonHandlerSvc: DiagramJsonHandlerService,
    registrySvc: EditorRegistryService,
    stickersSvc: StickersService,
    shapeSvc: ShapeSpawnerService,
    graphHelperSvc: GraphHelperService,
    preloadSvc: SimpleImagePreloadService,
    angCompSvc: AngularComponentService,
    sanitizeXssService: SanitizeXssService
  ) {
    this.serviceObj = {
      diagramUpdateSvc,
      jsonHandlerSvc,
      registrySvc,
      stickersSvc,
      shapeSvc,
      graphHelperSvc,
      preloadSvc,
      angCompSvc,
      sanitizeXssService
    };
  }

  public change(changes, forceModelUpdate = false) {
    return new ChangeCommand(changes)
      .injectServices(this.serviceObj)
      .prepareData()
      .forceModelUpdate(forceModelUpdate);
  }

  public group(commands) {
    return new GroupCommand(commands).injectServices(this.serviceObj);
  }

  public paste(data: ICopyData) {
    return new PasteCommand(data).injectServices(this.serviceObj);
  }
}
